import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { Link, useNavigate } from "react-router-dom";
import { PartsGrid } from "../../compenents/Parts/PartsGrid";
import { AddDialog } from "../../compenents/Parts/Dialog/AddDialog";

interface PartsProps {}

const Parts: React.FunctionComponent<PartsProps> = (props) => {
  const [quickAdd, setQuickAdd] = React.useState(false);
  return (
    <>
      <Container maxWidth={false}>
        <Grid container>
          <Grid item md={6}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
              Parts
            </Typography>
          </Grid>
          <Grid item md={6} textAlign={"right"}>
            <Button
              variant="contained"
              component={Link}
              to="/AddPart"
              startIcon={<AddIcon />}
              size="small"
              style={{ marginRight: 6 }}
            >
              Add
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              size="small"
              color="warning"
              onClick={() => {
                setQuickAdd(true);
              }}
            >
              Quick Add
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ mt: 1, width: "100%" }}>
          <PartsGrid></PartsGrid>
        </Box>
      </Container>
      <AddDialog
        isOpen={quickAdd}
        onClose={() => {
          setQuickAdd(false);
        }}
      ></AddDialog>
    </>
  );
};

export default Parts;
